module.exports = __webpack_public_path__ + "static/media/icon-pencil.332a846c.svg";